import { IMPORT_LISTINO } from "./constants";
import { post } from "./service";

/**
 * Function to fetch all the users.
 */

export const importListino = async (data) => {
	return post(IMPORT_LISTINO(), data);
};